import styled from 'styled-components';

const Card = styled.button`
  background: #ffffff;
  width: 100%;
  border-radius: 8px;
  height: 100%;

  @media (min-width: 992px) and (max-width: 1279px) {
    width: 336px;
  }

  @media (min-width: 1280px) {
    width: 360px;
  }

  @media () &:hover {
    background: #d5e5f0;
    cursor: pointer;
  }

  &:focus {
    background: #a8cbe2;
  }

  &:active {
    background: #a8cbe2;
  }

  .displayFlex {
    display: flex;
  }

  .row {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .courseModality {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 4px;
  }

  .DF {
    width: 75px;
  }

  .TC {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 40px;
    align-items: center;
  }

  .reinforcementCancelado {
    pointer-events: none;
    span,
    p {
      color: #8090bb;
    }
    div {
      color: #8090bb;
    }

    img {
      filter: brightness(1);
      filter: saturate(0);
    }
  }

  @media (min-width: 1280px) {
    width: 360px;
  }
`;

const TitleHeader = styled.div`
  display: flex;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  margin-right: 4px;
  color: #161d1f;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px;
  border-bottom: solid 1px #d5e5f0;
`;

const TextHeader = styled.div`
  display: flex;
`;

const Text = styled.div`
  padding: 1px 8px 3px 8px;
  background: #e2dffd;
  border-radius: 4px;
  color: #5b36f2;
  margin-right: 4px;
  font-size: 12px;
  width: max-content;
  font-weight: 700;
`;

const Body = styled.div`
  padding: 8px 12px 12px 12px;
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

const CardBody = styled.div`
  width: 100%;
  display: flex;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #161d1f;
  gap: 5px;
  .displayFlex {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .flexCalendar {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  img {
    margin-right: 0px;
  }
`;

export { Card, TitleHeader, Header, TextHeader, Text, Body, CardBody };
